export default "__VITE_ASSET__CFCtiWpv__"